module.exports = __webpack_public_path__ + "img/AF.1001a3ea.png";